import request from '@/utils/request'

// 查询潜在客户列表
export function getCompanyInfo() {
  return request({
    url: '/udi/tenant/get-for-record/',
    method: 'get',
    headers: {
      isSaas: true
    }
  })
}
// 修改潜在客户
export function updateCompany(data) {
  return request({
    url: '/udi/tenant/edit-for-record',
    method: 'put',
    data
  })
}
// 查询潜在客户列表
export function getApiInfo() {
  return request({
    url: '/udi/tenant/get-nmpa/',
    method: 'get'
  })
}
export function updateApi(data) {
  return request({
    url: '/udi/tenant/edit-nmpa',
    method: 'put',
    data
  })
}

export function downloadFile(file) {
  return request({
    url: `/udi/attachment/download?id=${file.id}`,
    method: 'get',
    responseType: 'blob'
  })
}
export function uploadFile(file) {
  return request({
    url: '/udi/attachment/upload',
    method: 'post',
    data: file,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}

export function getTenantInfo() {
  return request({
    url: '/udi/tenant/get-buy-service/',
    method: 'get'
  })
}

export function getDictData(dictType) {
  return request({
    url: `/system/dictData/list?dictType=${dictType}`,
    method: 'get'
  })
}

// 注册证管理-excel导入
export function submitCerti(data) {
  return request({
    url: '/register-certificate/import',
    method: 'post',
    data
  })
}

// 查询潜在客户列表
export function getCertiList(params) {
  return request({
    url: '/register-certificate/list',
    method: 'get',
    params
  })
}

// 查询潜在客户列表
export function getCertiDetail(id) {
  return request({
    url: `/register-certificate/${id}`,
    method: 'get'
  })
}

// 查询潜在客户列表
export function delCerti(id) {
  return request({
    url: `/register-certificate/delete/${id}`,
    method: 'post'
  })
}

// 爱博获取打印客户端下载接口
export function getSysConfigListPrivate() {
  return request({
    url: '/system/install-package/getUrl',
    method: 'post',
    data: {
      type: 'client-latest-url'
    }
  })
}
// saas获取打印客户端下载
export function getSysConfigList() {
  return request({
    url: '/udi/tenant/sys-config/filtrationTenant',
    method: 'get'
  })
}
// 获取当前租户
export function currentTenant() {
  return request({
    url: '/udi/tenant/current-tenant',
    method: 'get'
  })
}

/**
 * @description: 查询当前租户厂商识别代码数据
 * @return {*}
 */

export function getVendorCodeList() {
  return request({
    url: '/system/vendorCode/listAll',
    method: 'get'
  })
}

/**
 * @description: 更新当前租户厂商识别代码数据
 * @return {*}
 */

export function updateVendorCodeList(data) {
  return request({
    url: '/system/vendorCode',
    method: 'post',
    data
  })
}

// 查询生产许可证
export function getCompanyProduction(id) {
  return request({
    url: `/udi/tenant/${id}`,
    method: 'get'
  })
}

// 修改生存许可证
export function updateCompanyProduction(data) {
  return request({
    url: '/udi/tenant',
    method: 'put',
    data
  })
}
